import { Badge, Box, Divider, Grid, Group, Paper, Text, Title } from "@mantine/core";

import { PatientData } from "../hooks/useVisionTestData";
import { ReactNode } from "react";

interface PatientHeaderProps {
  patientData: PatientData;
  icon?: ReactNode;
  title?: string;
  subtitle?: string;
  overallStatus?: {
    label: string;
    color: string;
  };
}

export function PatientHeader({
  patientData,
  icon,
  title = "Vision Screening Results",
  subtitle = "Eye Examination Report",
  overallStatus,
}: PatientHeaderProps) {
  return (
    <Paper shadow="md" p="xl" radius="md" mb="md" withBorder>
      <Group justify="space-between" mb="lg">
        <Group>
          {icon && (
            <Box
              style={{
                width: 48,
                height: 48,
                backgroundColor: "var(--mantine-color-blue-6)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {icon}
            </Box>
          )}
          <div>
            <Title order={2}>{title}</Title>
            <Text c="dimmed" size="sm">
              {subtitle}
            </Text>
          </div>
        </Group>
        {overallStatus && (
          <Badge size="lg" color={overallStatus.color} variant="filled">
            {overallStatus.label}
          </Badge>
        )}
      </Group>

      <Divider my="md" />

      <Grid gutter="md">
        <Grid.Col span={3}>
          <Text size="sm" c="dimmed">
            Patient Name
          </Text>
          <Text>{patientData.name}</Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text size="sm" c="dimmed">
            Age
          </Text>
          <Text>{patientData.age != null ? `${patientData.age} years old` : "—"}</Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text size="sm" c="dimmed">
            Test Date
          </Text>
          <Text>{patientData.testDate}</Text>
        </Grid.Col>
      </Grid>
    </Paper>
  );
}
